import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, Package, Video, Handshake, Megaphone, Globe, CheckCircle, XCircle, ChevronDown, Play, ArrowRight, MessageCircle, Search, FileText, Rocket } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function CoachingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/3zsvshqebj.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      if (document.head.contains(playerScript)) document.head.removeChild(playerScript);
      if (document.head.contains(embedScript)) document.head.removeChild(embedScript);
    };
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Cómo funciona el coaching VIP 1:1?',
    a: 'Hacemos un diagnóstico profundo de tu negocio, definimos el plan de acción personalizado y trabajamos juntos en la implementación. La frecuencia y formato de las sesiones se adapta a tu situación específica.'
  }, {
    q: '¿Cuánto tiempo dura el programa?',
    a: 'Depende de tus objetivos y el nivel de acompañamiento que necesitas. Discutimos esto en la llamada inicial para diseñar el plan correcto para ti.'
  }, {
    q: '¿Necesito tener ya un negocio funcionando?',
    a: 'No necesariamente. Trabajo tanto con personas que quieren construir desde cero como con marcas establecidas que quieren escalar. Lo importante es que tengas la mentalidad y el capital para invertir.'
  }, {
    q: '¿Cómo me contacto para empezar?',
    a: 'Simplemente haz clic en el botón de WhatsApp y cuéntame brevemente tu situación. Te responderé personalmente para agendar una llamada de diagnóstico.'
  }];
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc] selection:text-black overflow-x-hidden" data-id="element-738">
      <VslHeader data-id="element-739" />

      {/* Scrolling Marquee Banner */}
      <div className="fixed top-[40px] md:top-[48px] left-0 right-0 z-40 bg-[#00f7fc] text-black py-1.5 overflow-hidden border-b border-black/10 shadow-md" data-id="element-740">
        <div className="whitespace-nowrap flex items-center animate-marquee text-[10px] md:text-xs font-black tracking-widest uppercase" data-id="element-741">
          <span className="mx-4" data-id="element-742">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-743">◆</span>
          <span className="mx-4" data-id="element-744">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-745">◆</span>
          <span className="mx-4" data-id="element-746">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-747">◆</span>
          <span className="mx-4" data-id="element-748">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-749">◆</span>
          <span className="mx-4" data-id="element-750">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-751">◆</span>
          <span className="mx-4" data-id="element-752">ESTRATEGIA PERSONALIZADA 1:1</span>

          {/* Duplicate for seamless loop */}
          <span className="mx-2" data-id="element-753">◆</span>
          <span className="mx-4" data-id="element-754">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-755">◆</span>
          <span className="mx-4" data-id="element-756">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-757">◆</span>
          <span className="mx-4" data-id="element-758">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-759">◆</span>
          <span className="mx-4" data-id="element-760">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-761">◆</span>
          <span className="mx-4" data-id="element-762">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-763">◆</span>
          <span className="mx-4" data-id="element-764">ESTRATEGIA PERSONALIZADA 1:1</span>
        </div>
      </div>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[500px] md:h-[700px] z-0 opacity-40" data-id="element-765">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-766" />
      </div>

      <main className="relative z-10 pt-32 md:pt-40 pb-20" data-id="element-767">
        {/* 2. HERO SECTION */}
        <section className="max-w-4xl mx-auto px-4 text-center mb-20 md:mb-32" data-id="element-768">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 px-4 py-1.5 rounded-full mb-6" data-id="element-769">
            <span className="relative flex h-2 w-2" data-id="element-770">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-771"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00f7fc]" data-id="element-772"></span>
            </span>
            <span className="text-[#00f7fc] font-bold text-xs uppercase tracking-widest" data-id="element-773">
              Coaching VIP 1:1 Exclusivo
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-white mb-6" data-id="element-774">
            Escala Tu Marca Con La Estrategia Exacta Que Generó{' '}
            <span className="text-[#00f7fc]" data-id="element-775">+$50M</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-base md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-776">
            Un plan de acción 100% personalizado para tu negocio. Ya sea que
            estés construyendo desde cero o escalando una marca establecida,
            trabajo contigo directamente para diseñar e implementar la
            estrategia correcta.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="w-full max-w-md mx-auto mb-12" data-id="element-777">
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
            boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
          }} data-id="element-778">
              <span className="absolute inset-0 rounded-xl animate-pulse" style={{
              boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
            }} data-id="element-779" />
              <MessageCircle className="relative z-10 w-6 h-6" data-id="element-780" />
              <span className="relative z-10" data-id="element-781">Contáctame en WhatsApp</span>
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-782">
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-783" />
              </div>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto border-t border-white/10 pt-8" data-id="element-784">
            <div data-id="element-785">
              <p className="text-3xl font-black text-white mb-1" data-id="element-786">$50M+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-787">
                Resultados colectivos
              </p>
            </div>
            <div data-id="element-788">
              <p className="text-3xl font-black text-white mb-1" data-id="element-789">10+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-790">
                Años de experiencia
              </p>
            </div>
            <div data-id="element-791">
              <p className="text-3xl font-black text-white mb-1" data-id="element-792">6</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-793">
                Áreas de expertise
              </p>
            </div>
          </motion.div>
        </section>

        {/* 3. VIDEO SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-794">
          <div className="text-center mb-8" data-id="element-795">
            <h2 className="text-2xl md:text-4xl font-black text-white mb-3" data-id="element-796">
              Mira Este Video Primero
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-797">
              Por Qué Este Coaching Es Diferente
            </p>
          </div>

          <div className="relative bg-gray-900 border border-[#00f7fc]/30 overflow-hidden shadow-2xl rounded-2xl" style={{
          boxShadow: '0 0 10px rgba(0, 247, 252, 0.15), 0 0 30px rgba(0, 247, 252, 0.08)'
        }} data-id="element-798">
            <style dangerouslySetInnerHTML={{
            __html: `wistia-player[media-id='3zsvshqebj']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3zsvshqebj/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`
          }} data-id="element-799" />
            <wistia-player media-id="3zsvshqebj" aspect="1.7777777777777777" data-id="element-800"></wistia-player>
          </div>
        </motion.section>

        {/* 4. EXPERTISE GRID */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-801">
          <div className="text-center mb-12" data-id="element-802">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-803">
              Áreas de Expertise
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-804">
              Domino Cada Área Donde Tu Marca Necesita Crecer
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-805">
            {[{
            icon: ShoppingCart,
            title: 'Ecommerce & DTC',
            desc: 'Marcas directas al consumidor, optimización de tiendas, estrategias de retención y escalamiento con paid traffic.'
          }, {
            icon: Package,
            title: 'Productos Digitales',
            desc: 'Creación, lanzamiento y escalamiento de infoproductos, cursos, membresías y software.'
          }, {
            icon: Video,
            title: 'Webinars & VSL Funnels',
            desc: 'Diseño de embudos de alta conversión: webinars en vivo, VSLs, páginas de ventas y secuencias de email.'
          }, {
            icon: Handshake,
            title: 'Afiliados & Pay Per Call',
            desc: 'Redes de afiliados, arbitraje de tráfico, pay per call y modelos de revenue share.'
          }, {
            icon: Megaphone,
            title: 'Meta Ads & YouTube Ads',
            desc: 'Estrategia de campañas, creativos, audiencias, retargeting y optimización de ROAS.'
          }, {
            icon: Globe,
            title: 'MLM & Marketing de Red',
            desc: 'Estrategias de reclutamiento digital, duplicación de equipos y construcción de marca personal para líderes de red.'
          }].map((item, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 hover:border-[#00f7fc]/30 transition-all duration-300 group" data-id="element-806">
                <div className="w-14 h-14 bg-[#00f7fc]/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-807">
                  <item.icon className="w-7 h-7 text-[#00f7fc]" data-id="element-808" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-809">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-810">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </motion.section>

        {/* 5. RESULTS SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-811">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-812">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00f7fc] to-blue-600" data-id="element-813"></div>

            <h2 className="text-2xl md:text-4xl font-black text-white text-center mb-12" data-id="element-814">
              +$50M Generados En Múltiples Industrias
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-815">
              <div className="text-center" data-id="element-816">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-817">$50M+</p>
                <p className="text-white font-bold mb-1" data-id="element-818">
                  Generados colectivamente
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-819">
                  En todas las áreas combinadas
                </p>
              </div>
              <div className="text-center" data-id="element-820">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-821">10+</p>
                <p className="text-white font-bold mb-1" data-id="element-822">Años de experiencia</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-823">
                  En marketing digital
                </p>
              </div>
              <div className="text-center" data-id="element-824">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-825">6</p>
                <p className="text-white font-bold mb-1" data-id="element-826">Modelos de negocio</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-827">
                  Dominados y probados
                </p>
              </div>
              <div className="text-center" data-id="element-828">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-829">1:1</p>
                <p className="text-white font-bold mb-1" data-id="element-830">
                  Coaching personalizado
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-831">
                  Plan único para tu negocio
                </p>
              </div>
            </div>
          </div>

          {/* Revenue Growth Screenshot */}
          <div className="mt-12 max-w-2xl mx-auto" data-id="element-832">
            <div className="text-center mb-6" data-id="element-833">
              <p className="text-[#00f7fc] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-834">
                Crecimiento Real — Mis Propios Números
              </p>
              <p className="text-gray-400 text-base" data-id="element-835">
                De $20K a $154K/mes en solo 4 meses. Esto es lo que pasa cuando
                aplicas la estrategia correcta.
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl" style={{
            boxShadow: '0 0 20px rgba(0, 247, 252, 0.1)'
          }} data-id="element-836">
              <img src="https://cdn.magicpatterns.com/uploads/xwr3dSQ4TK8CGc5hG5nfVJ/Screenshot_2026-04-08_at_4.38.44_PM.png" alt="Crecimiento de ingresos — de $20K en Diciembre a $154,919 en Marzo" className="w-full h-auto block" data-id="element-837" />
            </div>
          </div>
        </motion.section>

        {/* 5.5 CLIENT TESTIMONIALS */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-838">
          <div className="text-center mb-12" data-id="element-839">
            <span className="bg-[#00f7fc]/10 text-[#00f7fc] border border-[#00f7fc]/20 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-4 inline-block" data-id="element-840">
              Resultados Reales
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-841">
              Lo Que Dicen Mis Clientes 1:1
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-842">
              Todos estos clientes han generado más de 7 cifras con mi coaching.
              Escucha directamente de ellos — desliza para ver más →
            </p>
          </div>

          <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-2" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-843">
            {/* David Moreno - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-844">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-845">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-846">
                  <iframe src="https://player.vimeo.com/video/1163771829?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="David Moreno Testimonial" data-id="element-847" />
                </div>
                <div className="p-4" data-id="element-848">
                  <p className="text-sm font-bold text-white" data-id="element-849">David Moreno</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-850">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Richard & Laz - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-851">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-852">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-853">
                  <iframe src="https://player.vimeo.com/video/1163509676?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Richard & Laz Testimonial" data-id="element-854" />
                </div>
                <div className="p-4" data-id="element-855">
                  <p className="text-sm font-bold text-white" data-id="element-856">Richard & Laz</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-857">
                    Clientes 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Carwin - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-858">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-859">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-860">
                  <iframe src="https://player.vimeo.com/video/1163416902?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Carwin Testimonial" data-id="element-861" />
                </div>
                <div className="p-4" data-id="element-862">
                  <p className="text-sm font-bold text-white" data-id="element-863">Carwin</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-864">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Danel - Horizontal (16:9) - Below carousel */}
          <div className="max-w-3xl mx-auto mt-10" data-id="element-865">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-866">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-867">
                <iframe src="https://player.vimeo.com/video/1163511759?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Danel Testimonial en Entrevista" data-id="element-868" />
              </div>
              <div className="p-4" data-id="element-869">
                <p className="text-sm font-bold text-white" data-id="element-870">Danel</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-871">
                  Cliente 1:1 — Entrevista
                </p>
              </div>
            </div>
          </div>

          {/* Santi - Horizontal (16:9) - Below Danel */}
          <div className="max-w-3xl mx-auto mt-6" data-id="element-872">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-873">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-874">
                <iframe src="https://player.vimeo.com/video/1181337901?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Santi Latest testimonio" data-id="element-875" />
              </div>
              <div className="p-4" data-id="element-876">
                <p className="text-sm font-bold text-white" data-id="element-877">Santi</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-878">
                  Cliente 1:1
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* 6. QUALIFICATION SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-879">
          <div className="text-center mb-12" data-id="element-880">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-881">
              ¿Es Para Ti?
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-882">
              Solo Trabajo Con Las Personas Correctas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-883">
            {/* YES Column */}
            <div className="bg-emerald-900/10 border border-emerald-500/20 rounded-2xl p-8" data-id="element-884">
              <h3 className="text-xl font-bold text-emerald-400 mb-8 flex items-center gap-3" data-id="element-885">
                <CheckCircle className="w-6 h-6" data-id="element-886" />
                Este coaching ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-887">
                {[{
                t: 'Dueños de ecommerce',
                d: 'Que quieren escalar sus ventas con paid traffic y sistemas de retención.'
              }, {
                t: 'Creadores de productos digitales',
                d: 'Que quieren lanzar y vender con funnels de alta conversión.'
              }, {
                t: 'Emprendedores con oferta validada',
                d: 'Que quieren pasar de $10k a $100k/mes con estrategia y sistemas.'
              }, {
                t: 'Líderes de MLM',
                d: 'Que quieren construir su marca personal y reclutar digitalmente.'
              }, {
                t: 'Marcas DTC',
                d: 'Que quieren dominar Meta Ads y YouTube Ads para escalar agresivamente.'
              }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-888">
                    <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-889" />
                    <div data-id="element-890">
                      <p className="text-white font-bold text-sm mb-1" data-id="element-891">
                        {item.t}
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-892">
                        {item.d}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>

            {/* NO Column */}
            <div className="bg-red-900/10 border border-red-500/20 rounded-2xl p-8" data-id="element-893">
              <h3 className="text-xl font-bold text-red-400 mb-8 flex items-center gap-3" data-id="element-894">
                <XCircle className="w-6 h-6" data-id="element-895" />
                Este coaching NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-896">
                {['Personas que buscan resultados sin invertir', 'Emprendedores que no están dispuestos a ejecutar', 'Quienes esperan resultados de la noche a la mañana', 'Personas sin capital para invertir en herramientas y ads'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-897">
                    <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-898" />
                    <p className="text-gray-300 text-sm leading-relaxed" data-id="element-899">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-900">
            <p className="text-gray-300 mb-8 text-lg" data-id="element-901">
              Si te identificaste con el primer grupo, el siguiente paso es
              simple: escríbeme por WhatsApp y cuéntame sobre tu negocio.
            </p>
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-4 px-8 transition-all duration-300 transform hover:scale-[1.03] shadow-[0_0_20px_rgba(253,185,49,0.25)]" data-id="element-902">
              <MessageCircle className="w-5 h-5" data-id="element-903" />
              Quiero Hablar con Gabriel
            </a>
          </div>
        </motion.section>

        {/* 7. PROCESS SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-904">
          <div className="text-center mb-16" data-id="element-905">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-906">
              El Proceso
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-907">
              Cómo Funciona el Coaching VIP 1:1
            </p>
          </div>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-6 md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-[#00f7fc] before:via-[#00f7fc]/50 before:to-transparent" data-id="element-908">
            {[{
            num: '01',
            icon: Search,
            title: 'Diagnóstico Profundo',
            desc: 'Analizamos tu negocio, tu oferta, tu tráfico y tus números. Identificamos los cuellos de botella exactos que están limitando tu crecimiento.'
          }, {
            num: '02',
            icon: FileText,
            title: 'Plan de Acción Personalizado',
            desc: 'Diseñamos una estrategia específica para tu situación. No hay plantillas genéricas — cada plan es único para tu modelo de negocio, tu mercado y tus objetivos.'
          }, {
            num: '03',
            icon: Rocket,
            title: 'Implementación y Seguimiento',
            desc: 'Trabajamos juntos en la ejecución. Tienes acceso directo a mí para preguntas, revisiones y ajustes en tiempo real mientras escalas.'
          }].map((step, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group" data-id="element-909">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-black border-2 border-[#00f7fc] shadow-[0_0_15px_rgba(0,247,252,0.3)] shrink-0 md:order-1 md:group-odd:-ml-6 md:group-even:-mr-6 z-10" data-id="element-910">
                  <step.icon className="w-5 h-5 text-[#00f7fc]" data-id="element-911" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white/5 border border-white/10 p-6 rounded-2xl ml-6 md:ml-0 hover:border-[#00f7fc]/30 transition-colors" data-id="element-912">
                  <span className="text-[#00f7fc] font-black text-xl mb-2 block" data-id="element-913">
                    {step.num}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-914">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-915">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.section>

        {/* 8. FAQ SECTION */}
        <motion.section {...fadeIn} className="max-w-3xl mx-auto px-4 mb-24" data-id="element-916">
          <div className="text-center mb-12" data-id="element-917">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-918">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-919">Lo Que Más Me Preguntan</p>
          </div>

          <div className="space-y-4" data-id="element-920">
            {faqs.map((faq, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-921">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-922">
                  <span className="font-bold text-white pr-4" data-id="element-923">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-[#00f7fc] transition-transform duration-300 shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-924" />
                </button>
                <AnimatePresence data-id="element-925">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-926">
                      <div className="p-6 pt-0 text-gray-400 text-sm leading-relaxed border-t border-white/5 mt-2" data-id="element-927">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.section>

        {/* 9. FINAL CTA SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 text-center" data-id="element-928">
          <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border border-[#00f7fc]/20 rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-929">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-[#00f7fc]/10 blur-[100px] pointer-events-none" data-id="element-930"></div>

            <div className="relative z-10" data-id="element-931">
              <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-932">
                ¿Listo Para Escalar?
              </h2>
              <p className="text-xl text-[#00f7fc] font-bold mb-6 uppercase tracking-wider" data-id="element-933">
                El Próximo Paso Es Una Conversación
              </p>
              <p className="text-gray-400 text-lg mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-934">
                Escríbeme por WhatsApp, cuéntame sobre tu negocio y tus
                objetivos. Si veo que puedo ayudarte, agendamos una llamada de
                diagnóstico sin costo.
              </p>

              <div className="w-full max-w-md mx-auto mb-6" data-id="element-935">
                <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
                boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
              }} data-id="element-936">
                  <span className="absolute inset-0 rounded-xl animate-pulse" style={{
                  boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
                }} data-id="element-937" />
                  <MessageCircle className="relative z-10 w-6 h-6" data-id="element-938" />
                  <span className="relative z-10" data-id="element-939">
                    Contáctame Ahora en WhatsApp
                  </span>
                  <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-940">
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-941" />
                  </div>
                </a>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500 font-medium" data-id="element-942">
                <CheckCircle className="w-4 h-4 text-emerald-500" data-id="element-943" />
                <span data-id="element-944">
                  Respuesta en menos de 24 horas · Sin compromiso · 100%
                  confidencial
                </span>
              </div>
            </div>
          </div>
        </motion.section>
      </main>

      <Footer data-id="element-945" />
    </div>;
}